import { combineReducers } from 'redux';
import { REDUCER_NAME as OPERATOR_REDUCER_NAME } from 'domain/operations/constants';
import { REDUCER_NAME as ORDER_REDUCER_NAME } from 'domain/order/constants';
import { REDUCER_NAME as ADDRESS_BOOK_REDUCER_NAME } from 'domain/addressBook/constants';
import { REDUCER_NAME as STOCK_UNIT_REDUCER_NAME } from 'domain/stockUnit/constants';

import { REDUCER_NAME as RESULTS_REDUCER_NAME } from 'domain/order/results/constants';
import { REDUCER_NAME as LAYOUT_REDUCER_NAME } from 'domain/layout/constants';
import { REDUCER_NAME as FUSE_AUTH_REDUCER_NAME } from 'domain/fuse/auth/constants';
import { REDUCER_NAME as SHIPMENTS_REDUCER_NAME } from 'domain/shipment/constants';
import { REDUCER_NAME as MAP_REDUCER_NAME } from 'domain/fuse/maps/constants';
import { REDUCER_NAME as PAYMENTS_REDUCER_NAME } from 'domain/payment/constants';
import { REDUCER_NAME as SHIPMENT_ESCALATION_REDUCER_NAME } from 'domain/operations/dashboard/shipmentEscalation/constants';
import { REDUCER_NAME as FINANCE_REDUCER_NAME } from 'domain/finance/constants';
import { REDUCER_NAME as SHIPPER_REDUCER_NAME } from 'domain/shipper/constants';

import { REDUCER_NAME as USER_REDUCER_NAME } from 'domain/fuse/auth/users/constants';
import { REDUCER_NAME as BATCH_REDUCER_NAME } from 'domain/batch/constants';

import financeReducer from 'domain/finance/reducer';

import { REDUCER_NAME as OPERATIONS_DASHBOARD_REDUCER_NAME } from 'domain/operations/dashboard/constants';
import operationsDashboardReducer from 'domain/operations/dashboard/reducer';

import paymentsReducer from 'domain/payment/reducer';
import fuseAuthReducer from 'domain/fuse/auth/reducer';
import mapsReducer from 'domain/fuse/maps/reducer';

import UserReducer from 'domain/fuse/auth/users/reducer';
import operationsReducer from 'domain/operations/reducer';
import orderReducer from 'domain/order/reducer';
import resultsReducer from 'domain/order/results/reducer';

import addressBookReducer from 'domain/addressBook/reducer';
import stockUnitReducer from 'domain/stockUnit/reducer';

import layoutReducer from 'domain/layout/reducer';

import shipmentReducer from 'domain/shipment/reducer';
import shipperReducer from 'domain/shipper/reducer';

import batchReducer from 'domain/batch/reducer';
import driverReducer from 'domain/operations/drivers/reducer';
import listingReducer from 'circe/queryListing/reducer';
import { REDUCER_NAME as LISTING_REDUCER_NAME } from 'circe/queryListing/constants';

import { REDUCER_NAME as ITINRARY_STATUS_REDUCER_NAME } from 'domain/operations/drivers/itineraryStatus/constants';
import itineraryStatusReducer from 'domain/operations/drivers/itineraryStatus/reducer';
import { REDUCER_NAME as DRIVER_REDUCE_NAME } from 'domain/operations/drivers/constants';
import { REDUCER_NAME as PREFERENCES_REDUCER_NAME } from 'domain/fuse/preferences/constants';
import preferencesReducer from 'domain/fuse/preferences/reducer';

import { REDUCER_NAME as MANIFEST_REDUCER_NAME } from 'domain/manifest/constants';
import manifestReducer from 'domain/manifest/reducer';

import { REDUCER_NAME as FIREBASE_REDUCER_NAME } from 'domain/fuse/firebase/constants';
import firebaseReducer from 'domain/fuse/firebase/reducer';
import { REDUCER_NAME as TRIP_REDUCER_NAME } from 'domain/trip/constants';
import tripReducer from 'domain/trip/reducer';

const appReducer = combineReducers({
  [OPERATOR_REDUCER_NAME]: operationsReducer,
  [DRIVER_REDUCE_NAME]: driverReducer,
  [ORDER_REDUCER_NAME]: orderReducer,
  [ADDRESS_BOOK_REDUCER_NAME]: addressBookReducer,
  [STOCK_UNIT_REDUCER_NAME]: stockUnitReducer,
  [RESULTS_REDUCER_NAME]: resultsReducer,
  [LAYOUT_REDUCER_NAME]: layoutReducer,
  [FUSE_AUTH_REDUCER_NAME]: fuseAuthReducer,
  [MAP_REDUCER_NAME]: mapsReducer,
  [PAYMENTS_REDUCER_NAME]: paymentsReducer,
  [SHIPMENTS_REDUCER_NAME]: shipmentReducer,
  [FINANCE_REDUCER_NAME]: financeReducer,
  [SHIPPER_REDUCER_NAME]: shipperReducer,
  [OPERATIONS_DASHBOARD_REDUCER_NAME]: operationsDashboardReducer,
  [BATCH_REDUCER_NAME]: batchReducer,
  [LISTING_REDUCER_NAME]: listingReducer,
  [ITINRARY_STATUS_REDUCER_NAME]: itineraryStatusReducer,
  [PREFERENCES_REDUCER_NAME]: preferencesReducer,
  [MANIFEST_REDUCER_NAME]: manifestReducer,
  [FIREBASE_REDUCER_NAME]: firebaseReducer,
  [TRIP_REDUCER_NAME]: tripReducer,
  [USER_REDUCER_NAME]: UserReducer,
});

export default appReducer;
